import {Form} from "../../helpers/forms/Form";
import {GlobalState} from "./State/GlobalState";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class PublicTicketsForm extends Form {
    /** @var {GlobalState} */
    state;

    constructor(config) {
        super({
            fields: [],
            ...config,
        });

        // Initialize global state
        this.state = new GlobalState();

        // Initial render
        this.state.stageManager.renderStage();
    }
}

export {PublicTicketsForm}
